import tippy from 'tippy.js'

export default {
  mounted() {
    // We listen for `selectionchange` on the document to detect text selection changes
    // and then dispatch our custom event `SelectTextTooltip_selectionchanged`
    this.el.addEventListener('SelectTextTooltip_selectionchanged', () => {
      const selectedText = window.getSelection().toString().trim()
      if (selectedText) {
        const popoverContent = document.createElement('div')
        popoverContent.classList.add('flex', 'items-center', 'py-1')
        popoverContent.style.borderRadius = '10px'
        const explainButton = document.createElement('button')
        explainButton.textContent = 'Explain'
        popoverContent.appendChild(explainButton)
        const editButton = document.createElement('button')
        if (this.el.dataset.editButton !== 'false') {
          editButton.textContent = 'Edit'
          popoverContent.appendChild(editButton)
        }
        document.body.appendChild(popoverContent)

        const tip = tippy(this.el, {
          content: popoverContent,
          trigger: 'manual',
          placement: 'top',
          showOnCreate: true,
          interactive: true,
          getReferenceClientRect: () => {
            return window.getSelection().getRangeAt(0).getBoundingClientRect()
          },
        })

        tip.popper.classList.add('text-selection-tippy')

        explainButton.addEventListener('click', () => {
          this.pushEvent('explain', { text: selectedText })
        })

        editButton.addEventListener('click', () => {
          this.pushEventTo(this.el, 'edit_rte', { rte: this.el.dataset.rte })
        })
      }
    })
  },
}
